import { useState } from "react";
import { Sparkles, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const QuoteExplain = ({ leadId }) => {
  const [text, setText] = useState("");
  const [state, setState] = useState("idle");

  const run = async () => {
    setState("loading");
    setText("");
    try {
      const res = await fetch(`${API}/calc/leads/${leadId}/explain`, { method: "POST" });
      if (!res.ok) throw new Error();
      const reader = res.body.getReader();
      const decoder = new TextDecoder();
      let buf = "";
      for (;;) {
        const { done, value } = await reader.read();
        if (done) break;
        buf += decoder.decode(value, { stream: true });
        const parts = buf.split("\n\n");
        buf = parts.pop();
        for (const p of parts) {
          const ev = JSON.parse(p.replace(/^data: /, ""));
          if (ev.type === "delta") setText((t) => t + ev.content);
          if (ev.type === "error") throw new Error();
        }
      }
      setState("done");
    } catch (e) {
      setState("error");
    }
  };

  if (state === "idle") {
    return (
      <button type="button" onClick={run} className="mt-4 inline-flex items-center gap-2 text-sm font-medium text-[#102692] hover:underline" data-testid="quote-explain-btn">
        <Sparkles className="w-4 h-4 text-[#F97316]" /> Comprendre mon devis
      </button>
    );
  }
  return (
    <div className="mt-4 text-left bg-slate-50 rounded-xl p-4 text-sm text-gray-700 whitespace-pre-line" data-testid="quote-explain-text">
      {state === "error" ? "Explication indisponible pour le moment, appelez-nous au 01 48 20 98 27." : text}
      {state === "loading" && <Loader2 className="inline w-4 h-4 ml-1 animate-spin text-[#102692]" />}
    </div>
  );
};
